import { FormattedMessage } from 'react-intl';
import { BreadcrumbItem } from 'components/breadcrumb/breadcrumbModel';

export function ProfitabilityBreadcrumb({ breadcrumbItem }: { breadcrumbItem: BreadcrumbItem }) {
  const segment = breadcrumbItem.path.split('/').filter(Boolean).pop() ?? breadcrumbItem.path;
  return <FormattedMessage id={`profitability.${segment}.title`} />;
}
